import { Box, Flex } from '@chakra-ui/react'

import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

import { ElementProps } from '../../GenericElement/GenericElement'
import BrandedVoiceTipIcon from 'src/components/widgets/BrandedVoiceTipIcon/BrandedVoiceTipIcon'

const Element: React.FC<ElementProps> = ({ item, hasErrors }) => {
  const { brandColor } = useCurrentUser()
  const label = item.title

  return (
    <Flex alignItems="center">
      <Box opacity={item.hasVoiceTip ? '1' : '0.2'} ml={2} mr={3}>
        <BrandedVoiceTipIcon
          brandColor={brandColor}
          iconOutlineColor="white"
          w="24px"
          h="24px"
        />
      </Box>
      <Box flex="1 1 min-content">
        <Box
          as="h5"
          className="body-small"
          wordBreak="break-all"
          noOfLines={2}
          color={
            item.hasVoiceTip ? (hasErrors ? 'danger' : 'onyx') : 'graphite'
          }
        >
          {label || (item.hasVoiceTip ? 'Audio Recording' : 'Empty Audio')}
        </Box>
      </Box>
    </Flex>
  )
}

export default Element
